var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacancyDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72063 0C11.993 0 15.46 3.46663 15.46 7.72063C15.46 11.993 11.9933 15.46 7.72063 15.46C3.46691 15.46 0 11.9933 0 7.72063C0 3.46691 3.46663 0 7.72063 0ZM7.72063 1.25551C11.2998 1.25551 14.2044 4.14139 14.2044 7.72054C14.2044 11.2997 11.2998 14.2043 7.72063 14.2043C4.14148 14.2043 1.25559 11.2997 1.25559 7.72054C1.25559 4.14139 4.14148 1.25551 7.72063 1.25551ZM9.83816 8.45123L8.17035 7.5892V4.49727C8.17035 3.91635 7.30832 3.91635 7.30832 4.49727V7.85166C7.30832 8.00157 7.38328 8.15147 7.53319 8.22644L9.42584 9.21966C9.93182 9.50077 10.3441 8.71368 9.83815 8.45131L9.83816 8.45123ZM13.3238 8.17012H13.0614C12.4805 8.17012 12.4805 7.28939 13.0614 7.28939H13.3238C13.0989 4.53471 10.9064 2.34212 8.17046 2.13607V2.39846C8.17046 2.97938 7.28973 2.97938 7.28973 2.39846V2.13607C4.53505 2.34222 2.34246 4.53471 2.13641 7.28939H2.3988C2.97972 7.28939 2.97972 8.15141 2.3988 8.15141H2.13641C2.34256 10.9061 4.53505 13.0987 7.28973 13.3234V13.061C7.28973 12.4801 8.15175 12.4801 8.15175 13.061V13.3234C10.9064 13.0986 13.099 10.9061 13.3238 8.17012Z",
    fill: "#E7B92A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancyDuration);
export default __webpack_public_path__ + "static/media/vacancyDuration.cab0b165b71f7935c70bb90d017b71fb.svg";
export { ForwardRef as ReactComponent };